import React from 'react';
import FerramentasIA from '../components/FerramentasIA';

const AssistenteIA = () => {
  return (
    <div className="p-6">
      <FerramentasIA />
    </div>
  );
};

export default AssistenteIA;
